<template>
  <div style="display: inline-flex">
  
    <Button :label="$t('library.cycle.delete_button')" 
      class="p-button-outlined" icon="icon-delete" iconPos="left" 
      @click="buttonClick" />

    <IrinoxDialogDark :visible="dialog.delete" mode="confirm" 
      :leftB="$t('library.cycle.delete_dialog_cancel')" @click:left-button="() => {dialog.delete = false;}" 
      :rightB="$t('library.cycle.delete_dialog_confirm')" @click:right-button="deleteRecipe" 
      :message="$t('library.cycle.delete_dialog')"
      icon="assets/irinox/icons/delete_big.svg" />

    <!--                    -->
    <!-- ERRORS and SUCCESS -->
    <!--                    -->
    <IrinoxDialogDark :visible="dialog.error" 
      mode="error" 
      :message="$t('library.dialog_error')"
      :life="3000" 
      @update:visible="dialog.error = $event" />
    <IrinoxDialogDark :visible="dialog.success" 
      mode="success" 
      :message="$t('library.cycle.delete_dialog_deleted')"
      :life="3000" 
      @update:visible="dialog.success = $event" />

  </div>

</template>

<script>
import RecipeService from '../../../service/RecipeService';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';

export default {

  components: {
    IrinoxDialogDark,
    },
    props: {
      serialNumber: String,
      recipe: Object,
      appliance: Object
    },
    data() {
        return {
          dialog: {
            error: false,
            delete: false,
            success: false
          },
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
        }),
    },
    watch: {
    },
    created() {
      this.recipeService = new RecipeService();
    },
    mounted() {
    },
    methods: {
      buttonClick() {
        this.dialog.delete = true;
      },
      deleteRecipe() {
        this.dialog.delete = false;
        this.recipeService.deleteRecipe(this.personaltoken, this.recipe.id, this.serialNumber)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.success = true;
              setTimeout(function() {
                if(this.serialNumber) {
                  this.$router.push({ name: 'appliance-library', params: { serialNumber: this.serialNumber } })
                } else {
                  this.$router.push({ name: 'library' })
                }
              }.bind(this), 3000);
            } else {
              this.dialog.error = true;
              console.error("EXCEPTION "+JSON.stringify(data));
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      }
    }

}
</script>

<style scoped>

</style>